import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsObject, IsOptional } from 'class-validator';
import { WebMerchantExposeGroup } from '../interface';
export class ReadWebMerchantOrderConfirmationWrapperDto {
}
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsObject({ always: true }),
    __metadata("design:type", Object)
], ReadWebMerchantOrderConfirmationWrapperDto.prototype, "style", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsObject({ always: true }),
    __metadata("design:type", Object)
], ReadWebMerchantOrderConfirmationWrapperDto.prototype, "header", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsObject({ always: true }),
    __metadata("design:type", Object)
], ReadWebMerchantOrderConfirmationWrapperDto.prototype, "content", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsObject({ always: true }),
    __metadata("design:type", Object)
], ReadWebMerchantOrderConfirmationWrapperDto.prototype, "packingInstructions", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsObject({ always: true }),
    __metadata("design:type", Object)
], ReadWebMerchantOrderConfirmationWrapperDto.prototype, "diningOptions", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsObject({ always: true }),
    __metadata("design:type", Object)
], ReadWebMerchantOrderConfirmationWrapperDto.prototype, "disclaimer", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsObject({ always: true }),
    __metadata("design:type", Object)
], ReadWebMerchantOrderConfirmationWrapperDto.prototype, "orderTotal", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsObject({ always: true }),
    __metadata("design:type", Object)
], ReadWebMerchantOrderConfirmationWrapperDto.prototype, "footer", void 0);
//# sourceMappingURL=ReadWebMerchantOrderConfirmationWrapperDto.js.map